import React from "react";
import { addDays, format } from "date-fns";
import { es } from "date-fns/locale";

// Segmented day selector: Hoy · Mañana · [weekday]. Shows today + next 2 days.
export const DayTabs = ({ value, onChange, counts = {} }) => {
    const base = new Date();
    const days = [0, 1, 2].map((i) => {
        const d = addDays(base, i);
        const key = format(d, "yyyy-MM-dd");
        const raw = i === 0 ? "Hoy" : i === 1 ? "Mañana" : format(d, "EEE d", { locale: es });
        return { key, label: raw.charAt(0).toUpperCase() + raw.slice(1) };
    });
    return (
        <div className="flex gap-1 rounded-full bg-secondary p-1 mb-4" data-testid="day-tabs">
            {days.map((d) => {
                const active = value === d.key;
                const count = counts[d.key];
                return (
                    <button
                        key={d.key}
                        onClick={() => onChange(d.key)}
                        className={`flex-1 flex items-center justify-center gap-1.5 rounded-full py-1.5 text-sm transition-colors ${active ? "bg-white shadow-sm text-[hsl(var(--trulyn-navy))] font-semibold" : "text-muted-foreground hover:text-foreground font-medium"}`}
                        data-testid={`day-tab-${d.key}`}
                    >
                        {d.label}
                        {count != null && (
                            <span className={`text-[10px] rounded-full px-1.5 min-w-[18px] leading-4 tabular-nums ${active ? "bg-[hsl(var(--accent))] text-[hsl(var(--accent-foreground))]" : "bg-muted-foreground/15 text-muted-foreground"}`}>{count}</span>
                        )}
                    </button>
                );
            })}
        </div>
    );
};
